const BASE_URL = process.env.REACT_APP_BASE_API_URL +'/';

export const _request = async ({
  target,
  method = 'GET',
  params = null,
  contentType = 'json' // 'json' (default) | 'urlencoded'
}) => {
  let url = `${BASE_URL}${target}`;

  const options = {
    method: method,
    headers: {}
  };

  const token = localStorage.getItem('token');
  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  // Ako je GET/HEAD, parametri idu u URL (query string)
  if (params && (method === 'GET' || method === 'HEAD')) {
    const queryParams = new URLSearchParams(params).toString();
    url += `?${queryParams}`;
  }
  // Ako nije GET/HEAD, parametri idu u body
  else if (params) {
    if (contentType === 'urlencoded') {
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      options.body = new URLSearchParams(params).toString();
    } else {
      // default: JSON
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(params);
    }
  }

  try {

    // console.log('url',url)
    // console.log('options',options)
    const response = await fetch(url, options);

    // Ako je token istekao
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = '/authentication/simple/login'; // zamijeni sa svojom login rutom
      return Promise.reject(new Error('Unauthorized'));
    }


    if (!response.ok) {
      let errorBody = {};
      const contentType = response.headers.get('Content-Type');

      if (contentType && contentType.includes('application/json')) {
        try {
          errorBody = await response.json();
        } catch (_) {
          errorBody = {};
        }
      } else {
        try {
          errorBody = { message: await response.text() };
        } catch (_) {
          errorBody = {};
        }
      }

      const error = new Error(`HTTP error! status: ${response.status}`);
      error.status = response.status;
      error.response = response;
      error.body = errorBody;
      throw error;
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const _requestForm = async ({ target, method, params = null }) => {
  const url = `${BASE_URL}${target}`;

  const options = {
    method: method,
    headers: {
      // 'Content-Type' ne mora biti postavljen, FormData će automatski postaviti odgovarajući tip
    }
  };

  const token = localStorage.getItem('token');
  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }

  const formData = new FormData();

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value instanceof File) {
        // Ako je vrednost File objekat (slika ili bilo koji fajl), dodajemo je kao fajl
        formData.append(key, value);
      } else {
        // Inače, dodajemo parametar kao tekst
        //console.log('*** key',key, value)
        formData.append(key, value);
      }
    }
  }

  for (let [key, value] of formData.entries()) {
    console.log(`entries ${key}:`, value);
  }



  options.body = formData;

  try {

    console.log('url',url)
    console.log('options',formData)
    const response = await fetch(url, options);

    // Ako je token istekao
    if (response.status === 401 || response.status === 403) {
      localStorage.clear();
      window.location.href = '/authentication/simple/login'; // zamijeni sa svojom login rutom
      return Promise.reject(new Error('Unauthorized'));
    }

    const data = await response.json(); // JSON može sadržati i grešku

    if (!response.ok) {
      // Umesto da baca Error sa samo tekstom, baci sve podatke
      let error;
      if (data.errors) {
        error= {};
        error['error'] = data.errors;
      } else {
        error = new Error(data.message || 'Request failed');
        error.status = response.status;
        error.response = data;
      }
      throw error;
    }

    return data;
  } catch (error) {

    console.log('aaaa',error);

    // Ako fetch nije uspeo zbog mrežne greške (nema JSON-a)
    if (error.name === 'SyntaxError') {
      console.error('Nevalidan JSON:', error);
    }
    throw error;
  }
};


export const _export = async ({ target, method, params = null }) => {
  const url = `${BASE_URL}${target}?`;

  const dataParams = new URLSearchParams(params);
  const token = localStorage.getItem('token');

  fetch(url + dataParams.toString(), {
    method: method,
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
      .then(response => {
        if (!response.ok) throw new Error('Greška pri preuzimanju');
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'export.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(err => {
        console.error('Greška:', err);
      });
};

// ====================================================================================================== //

export async function _exportPDF(target, params = undefined, download = false, method = 'POST') {
  target = `${BASE_URL}${target}${target.includes('?') ? '' : '?'}`;
  const token = localStorage.getItem('token');

  const res = await fetch(target, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: method === 'GET' || params === undefined ? undefined : JSON.stringify(params)
  });

  if (!res.ok) {
    const err = await safeText(res);
    throw new Error(`PDF greška ${res.status}${err ? `: ${err}` : ''}`);
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);

  if (download) {
    const name = getFilename(res.headers.get('Content-Disposition')) || 'export.pdf';
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } else {
    // Otvori u novom tabu (pozivaj iz click handlera da popup ne bude blokiran)
    window.open(url, '_blank', 'noopener,noreferrer');
    // Vrati URL da eventualno kasnije možeš URL.revokeObjectURL(url)
  }

  return url;
}

async function safeText(res) {
  try { return await res.text(); } catch { return ''; }
}

function getFilename(cd) {
  if (!cd) return null;
  const m1 = cd.match(/filename\*=UTF-8''([^;]+)/i);
  if (m1) return decodeURIComponent(m1[1]);
  const m2 = cd.match(/filename="?([^\";]+)"?/i);
  return m2 ? m2[1] : null;
}

// ====================================================================================================== //
